module.exports = __webpack_public_path__ + "static/media/YF81_5.87a12b98.jpg";